import axios from 'axios';

/**
 * Fetches the alumni list
 * @returns {Promise} class - a promise of alumni list to be resolved.
 */
export async function getAlumniList(alphabet, limit, offset) {
	const response = await axios.get(`/v1/alumni/filter?alphabet=${alphabet}&limit=${limit}&offset=${offset}`);
	return response;
}

/**
 * Fetches the an alumni profile using the id
 * @returns {Promise} class - a promise of alumni to be resolved.
 */
export async function getAlumniProfile(id) {
	const response = await axios.get(`/v1/alumni/${id}`);
	return response;
}
